import _ from 'lodash';
import store from '../redux/store';

const cleanIcon = (icono) => {
  if (!icono) return 'solar:widget-3-outline';
  return String(icono).replace(/[\r\n]+/g, '').trim() || 'solar:widget-3-outline';
};

const isIconify = (icono) => {
  if (!icono) return true;
  const str = String(icono).trim();
  if (str.startsWith('icon-')) return false;
  return true;
};

const adaptSubMenus = (subMenus) => {
  if (!subMenus || !Array.isArray(subMenus)) return subMenus;
  return subMenus.map((sub) => {
    const rawIcon = cleanIcon(sub.icono);
    return {
      ...sub,
      icono: rawIcon,
      iconify: sub.iconify !== undefined ? sub.iconify : isIconify(rawIcon),
      menus: sub.menus ? adaptSubMenus(sub.menus) : undefined,
    };
  });
};

export const menuListAdapter = (data) => {
  const userData = store.getState().authReducer.userData;
  const menuHome = [];

  if (userData?.realm_access?.roles?.includes('acceso-corredores')) {
    const menuLista = data?.map((menu) => {
      const rawIcon = cleanIcon(menu.icono);
      if (menu.nombre === 'Mi Level') {
        return {
          idMenu: 0,
          nombre: menu.nombre,
          icono: 'solar:home-linear',
          url: menu.url,
          menus: adaptSubMenus(menu.menus),
          visible: true,
          closeable: false,
          external: false,
          target: null,
          iconify: true,
        };
      }
      return {
        idMenu: menu.idMenu,
        nombre: menu.nombre,
        icono: rawIcon,
        url: menu.url,
        menus: adaptSubMenus(menu.menus),
        visible: true,
        closeable: true,
        external: [
          'Mis Cotizaciones',
          'Mis Evaluaciones',
          'Mis Reservas',
          'Agenda de Entrega',
        ].includes(menu.nombre),
        target: [
          'Mis Cotizaciones',
          'Mis Evaluaciones',
          'Mis Reservas',
          'Agenda de Entrega',
        ].includes(menu.nombre)
          ? '_blank'
          : null,
        iconify: isIconify(rawIcon),
      };
    });
    menuHome.push(...(menuLista || []));
    return menuHome;
  } else {
    menuHome.push(
      {
        idMenu: 0,
        nombre: `Home`,
        icono: 'solar:home-linear',
        visible: false,
        closeable: false,
        external: false,
        target: null,
        iconify: true,
      },
      {
        idMenu: 1,
        nombre: `Levelges`,
        icono: 'icon-euro',
        url: 'https://levelges.cl/eurocorpsga/Account/LoginExterno?',
        visible: false,
        closeable: false,
        external: true,
        target: '_blank',
        iconify: false,
      },
    );
  }

  const menuLista = data?.map((menu) => {
    const rawIcon = cleanIcon(menu.icono);
    return {
      idMenu: menu.idMenu,
      nombre: menu.nombre,
      icono: rawIcon,
      url: menu.url,
      menus: adaptSubMenus(menu.menus),
      visible: true,
      closeable: true,
      external: false,
      target: null,
      iconify: isIconify(rawIcon),
    };
  });

  return _.concat(menuHome, menuLista || []);
};

export default {
  menuListAdapter,
};
